import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiTruck, FiRefreshCw, FiAward, FiLock, FiPackage } from 'react-icons/fi';

/**
 * TrustBar — horizontal strip of trust signals.
 * variant: 'strip' (compact, 1 row) | 'cards' (larger cards grid)
 */
const TRUST_ITEMS = [
  {
    icon: <FiShield aria-hidden="true" />,
    title: 'Certified Authentic',
    desc: 'Every gemstone comes with full provenance documentation',
  },
  {
    icon: <FiLock aria-hidden="true" />,
    title: 'Secure Payment',
    desc: '256-bit SSL encryption on every transaction',
  },
  {
    icon: <FiTruck aria-hidden="true" />,
    title: 'Worldwide Delivery',
    desc: 'Insured shipping to 50+ countries',
  },
  {
    icon: <FiRefreshCw aria-hidden="true" />,
    title: '30-Day Returns',
    desc: 'Full refund if you are not completely satisfied',
  },
  {
    icon: <FiAward aria-hidden="true" />,
    title: 'Ethically Sourced',
    desc: 'Direct from Ethiopian mines — fair trade certified',
  },
  {
    icon: <FiPackage aria-hidden="true" />,
    title: 'Premium Packaging',
    desc: 'Luxury gift box included with every order',
  },
];

const TrustBar = ({ variant = 'strip', className = '' }) => {
  if (variant === 'strip') {
    return (
      <div className={`trust-strip ${className}`} role="list" aria-label="Trust and security guarantees">
        {TRUST_ITEMS.slice(0, 4).map((item) => (
          <div key={item.title} className="trust-strip__item" role="listitem">
            <span className="trust-strip__icon">{item.icon}</span>
            <span className="trust-strip__label">{item.title}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`trust-cards ${className}`} role="list" aria-label="Roha Jewellery guarantees">
      {TRUST_ITEMS.map((item) => (
        <article key={item.title} className="trust-card" role="listitem">
          <div className="trust-card__icon" aria-hidden="true">{item.icon}</div>
          <h3 className="trust-card__title">{item.title}</h3>
          <p className="trust-card__desc">{item.desc}</p>
        </article>
      ))}
    </div>
  );
};

export default TrustBar;
